import Navbar from "./components/frontend/Navbar";
import Hero from "./components/frontend/Hero";
import About from "./components/frontend/About";
import Program from "./components/frontend/Program";
import Services from "./components/frontend/Services";
import Book from "./components/frontend/Book";
import FAQ from "./components/frontend/FAQ";
import Contact from "./components/frontend/Contact";
import Footer from "./components/frontend/Footer";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Team from "./components/frontend/Team";
import FloatingSocials from "./components/frontend/FloatingSocials";
import FloatingWhatsApp from "./components/frontend/FloatingWhatsApp";
import Course from "./components/frontend/Course";
import ScrollToTop from "./components/ui/ScrollToTop";
import RiskDisclaimer from "./components/policies/RiskDisclaimer";
import PrivacyPolicy from "./components/policies/PrivacyPolicy";
import TermsConditions from "./components/policies/TermsConditions";
import RefundPolicy from "./components/policies/RefundPolicy";
import { Toaster} from "sonner";
import TheDifference from "./components/frontend/TheDifference";
import Partnership from "./components/frontend/Partnership";
import TheRealityGap from "./components/frontend/TheRealityGap";
import TargetAudience from "./components/frontend/TargetAudience";
import CTASection from "./components/frontend/CTASection";
import AutoContactPopup from "./components/frontend/AutoContactPopup";
import ScrollToHash from "./components/frontend/ScrollToHash";
import NotFound from "./components/frontend/NotFound";


function App() {
    return (
        <div className="bg-gradient-to-b from-bg-light-1 to-bg-light-2 dark:from-bg-dark-1 dark:to-bg-dark-2">
          <Router>
              <ScrollToTop />
              <ScrollToHash />
              <Navbar />
              <FloatingSocials />
              <Routes>
                  <Route path="/" element={
                      <>
                          <Hero />
                          <AutoContactPopup />
                          <About />
                          <TheRealityGap />
                          <TheDifference />
                          <Partnership />
                          <Program />
                          <TargetAudience/>
                          <CTASection />
                          <Services />
                          <Book />
                          <Team />
                          <FAQ />
                          <Contact />
                      </>
                  } />

                  <Route path="/courses" element={<Course />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/policies/risk-disclaimer" element={<RiskDisclaimer />} />
                  <Route path="/policies/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/policies/terms-and-conditions" element={<TermsConditions />} />
                  <Route path="/policies/refund-policy" element={<RefundPolicy />} />
                  <Route path="*" element={<NotFound />} />

              </Routes>
              <FloatingWhatsApp />
              <Footer />
              <Toaster
                  position="top-right"
                  toastOptions={{
                      style: {
                          marginTop: '1rem',
                          marginRight: '1rem',
                      },
                  }}
              />
          </Router>
        </div>
  );
}

export default App;
